var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "c-reservation-summary__item" }, [
      _c("div", { staticClass: "c-reservation-summary__label" }, [
        _vm._v(
          "\n            " +
            _vm._s(_vm.$t("BranchReservation.Summary.Voucher.title")) +
            "\n        "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "c-reservation-summary__voucher" }, [
        _c("div", { staticClass: "c-reservation-voucher" }, [
          _c("div", { staticClass: "c-reservation-voucher__input" }, [
            _c(
              "div",
              { staticClass: "c-form__item c-form__item--text has-addon" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.voucher,
                      expression: "voucher",
                    },
                  ],
                  staticClass: "form-control c-form__input",
                  attrs: {
                    type: "text",
                    name: "voucher",
                    placeholder: _vm.placeholder,
                    id: "voucher",
                    "aria-invalid": "false",
                    readonly: _vm.isUpdatingVoucher || !_vm.isInitialized,
                  },
                  domProps: { value: _vm.voucher },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.onVoucherAddClick.apply(null, arguments)
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.voucher = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    ref: "submitButton",
                    staticClass: "c-btn c-btn--secondary",
                    class: {
                      "is-loading": _vm.isUpdatingVoucher,
                    },
                    attrs: { type: "button", disabled: !_vm.isInitialized },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.onVoucherAddClick.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(
                          _vm.$t("BranchReservation.Summary.Voucher.add")
                        ) +
                        "\n                        "
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.vouchers
      ? _c(
          "div",
          { staticClass: "c-reservation-voucher__codes" },
          _vm._l(_vm.vouchers, function (voucher) {
            return _c(
              "div",
              {
                key: voucher.cart_id,
                staticClass: "c-reservation-voucher__item",
              },
              [
                _c("span", { staticClass: "sc-code" }, [
                  _vm._v(_vm._s(voucher.code)),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--invisible",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.onVoucherDeleteClick(voucher.cart_id)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa fa-close" })]
                ),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }